import styled from 'styled-components';

const AssistiveText = styled.div`
  min-height: 24px;
  line-height: 23px;
  font-size: 13px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  letter-spacing: 0.16px;
`;

export default AssistiveText;
